module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerut0a-ch1501",
      "epub:type": "division",
      "id": "ut0a-ch15"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerut0a-ch1501"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chilashvol20005#toc"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("US Senate, Lyman Trumbull, Judiciary Committee Reports S. Nos. 60 & 61 (Freedmen’s Bureau and Civil Rights Bills)")]), _vm._v(" "), _c('h1', {
    staticClass: "cs",
    attrs: {
      "role": "doc-subtitle"
    }
  }, [_vm._v("January 11, 1866"), _c('a', {
    staticClass: "fnref",
    attrs: {
      "href": "#/chilashvol20268#fn18",
      "id": "fn18r",
      "role": "doc-noteref"
    }
  }, [_vm._v("18*")])])]), _vm._v(" "), _c('section', [_c('h2', {
    staticClass: "ahaft",
    attrs: {
      "id": "ahaft1801"
    }
  }, [_vm._v("Reports from Committees.")]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("Mr. TRUMBULL, from the Committee on the Judiciary, to whom was referred the bill (S. No. 60) to enlarge the powers of the Freedmen’s Bureau, reported it with amendments.")]), _vm._v(" "), _c('p', [_vm._v("He also, from the same committee, to whom was referred the bill (S. No. 61) to protect all persons in the United States in their civil rights, and furnish the means of their vindication, reported it with amendments.")]), _vm._v(" "), _c('p', [_vm._v("Mr. TRUMBULL. I desire to give notice that when these bills shall have been printed, with the amendments, I will call the attention of the Senate to them at an early day.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21a23da6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-lash-vol2-0025.vue
// module id = 126
// module chunks = 0